export default __webpack_public_path__ + "static/media/carson-project-5.04a9eb43.webp";